import { createFileRoute } from "@tanstack/react-router";
import { routeOptions } from "@/pages/index";
import { enRouteOptions } from "@/lib/route-i18n";

export const Route = createFileRoute("/en/")(
  enRouteOptions(routeOptions, {
    svPath: "/",
    title: 'Alcohol Licence Knowledge Test Sweden 2026 – Practice Free',
    description: 'Practice for the Swedish alcohol serving licence knowledge test (kunskapsprov) in English: real exam questions, timed mock tests and per-topic statistics. 5 free questions a day.',
    ogImage: "https://alkoholprovet.se/og/default.jpg",
    noindex: false,
  }),
);
